/**
 * sessionStorage 封装工具
 */
export const SessionStorage = {
    /**
     * 设置数据
     * @param key 键名
     * @param value 值
     */
    set<T>(key: string, value: T): void {
        try {
            sessionStorage.setItem(key, JSON.stringify(value))
        } catch (error) {
            console.warn(`SessionStorage.set 失败:`, error)
        }
    },

    /**
     * 获取数据
     * @param key 键名
     * @returns 解析后的数据，如果不存在或解析失败则返回 null
     */
    get<T>(key: string): T | null {
        try {
            const item = sessionStorage.getItem(key)
            if (item === null) {
                return null
            }
            return JSON.parse(item) as T
        } catch (error) {
            console.warn(`SessionStorage.get 失败:`, error)
            return null
        }
    },

    /**
     * 移除数据
     * @param key 键名
     */
    remove(key: string): void {
        try {
            sessionStorage.removeItem(key)
        } catch (error) {
            console.warn(`SessionStorage.remove 失败:`, error)
        }
    },

    /**
     * 清空所有数据
     */
    clear(): void {
        try {
            sessionStorage.clear()
        } catch (error) {
            console.warn(`SessionStorage.clear 失败:`, error)
        }
    },

    /**
     * 检查键是否存在
     * @param key 键名
     */
    has(key: string): boolean {
        return sessionStorage.getItem(key) !== null
    }
}